export default "__VITE_ASSET__CLbYQPep__"